module.exports = __webpack_public_path__ + "media/application/images/logo_white-794fa3d7d7e72addcd9e16359090e9b0.svg";